module.exports = __webpack_public_path__ + "static/media/g-5-c.af4d601a.jpg";